import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { selectListItems } from '../../../../../../redux/library/selector';
import { users } from '../../../../../../redux/users/action';
import { selectUsersListItems, selectUsersQueryItems } from '../../../../../../redux/users/selector';
import UsersComponent from '../components/users-component';
import { settings } from '../../../../../../redux/settings/actions';
import UploadFiles from '../../../../../../models/UploadFile';
import { selectCurrent } from '../../../../../../redux/settings/selectors';

const ManagementUser = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const parmas: any = useParams();
    const libraryData = useSelector(selectListItems)
    const userItems = useSelector(selectUsersListItems)
    const [isQuery, setIsQuery] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [selectusers, setSelectusers] = useState<any>({});
    const eventBookingsQuery = useSelector(selectUsersQueryItems);
    const [openConfirmationProfileFile, setOpenConfirmationProfileFile] = React.useState(false);
    const [openImageFile, setOpenImageFile] = useState<any>([]);
    const { getUploadFiles } = useAppSelector(selectCurrent)

    const fetchEventBookingsQueryById = () => {
        dispatch(users.query({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/iam/users/query`,
            entity: 'users',
            jsonData: {
                Records: [
                    {
                        Id: parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true);
        });
    }

    useEffect(() => {
        fetchEventBookingsQueryById();
    }, []);

    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectusers({ ...selectusers, [field]: event });
    }

    const handleBasicFormChange: any = (event: any, field: string) => {
        setSelectusers({ ...selectusers, [field]: event });
    }
    //image picker logourl
    const changeProfileImage = (templateField: any, fileType: any, selectedCommunity: any) => {
        dispatch(settings.set({ getUploadFiles: 'open' }))
        setOpenConfirmationProfileFile(true)
        setOpenImageFile({
            currentFileSrc: selectusers?.ProfilePictureUrl || templateField,
            folder: 'user',
            type: fileType
        })


    }

    const handleLogoSubmit = (data: any) => {
        const ProfilePictureUrlData = {
            ProfilePictureUrl: data
        }
        setSelectusers({ ...selectusers, ...ProfilePictureUrlData })
    }

    const handleClose = () => {

        setOpenConfirmationProfileFile(false)

        dispatch(settings.set({ getUploadFiles: 'close' }))

    }



    useEffect(() => {
        if (isQuery) {
            setSelectusers(eventBookingsQuery?.result?.items);
        }
    }, [isQuery]);

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();

        if (parmas?.id > 0) {
            await dispatch(users.resetAction({ actionType: 'update' }))
            await dispatch(users.update({
                url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/iam/users`, entity: 'users', jsonData: {
                    Context: {},
                    Records: [
                        selectusers
                    ]

                }
            })).then(() => {
                back()
            })

        } else {
            await dispatch(users.resetAction({ actionType: 'create' }))
            await dispatch(users.create({
                url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/iam/users`, entity: 'users', jsonData: {

                    Context: {},
                    Records: [
                        selectusers
                    ]

                }
            })).then(() => {
                back()
            })

        }

    }



    const back = () => {
        navigate('/management/organization/iam/users');
    }

    return (
        <>
            {getUploadFiles == 'open' && openConfirmationProfileFile &&
                <UploadFiles currentFilesSrc={openImageFile?.currentFileSrc}
                    folder={openImageFile?.folder}
                    handleClose={handleClose}
                    handleFilesSubmit={handleLogoSubmit}
                    type={openImageFile?.type}
                    ownerId={parmas?.id}
                />
            }


            {eventBookingsQuery?.isLoading ? <PageLoader /> :
                <UsersComponent
                    handleInnerFormChange={handleInnerFormChange}
                    users={userItems?.result?.items}
                    selectusers={selectusers}
                    handleBasicFormChange={handleBasicFormChange}
                    libraryData={libraryData}
                    back={back}
                    changeProfileImage={changeProfileImage}
                    handleFormSubmit={handleFormSubmit}



                />
            }
        </>
    );
}

export default ManagementUser;
